/* eslint-disable camelcase, max-lines-per-function */

const SELECTORS = {
  CONTAINER: ".js-product-details-delivery-dates-container",
  SPINNER: ".js-product-details-delivery-dates-spinner",
  CUTOFF: ".js-product-details-delivery-dates-cutoff",

  COMPOSITION_CUTOFF: ".js-product-details-delivery-dates-current-composition-cutoff",
  COMPOSITION_SIZE: ".js-product-details-delivery-dates-current-composition-size",
  COMPOSITION_CUTOFF_TIME: ".js-product-details-delivery-dates-current-composition-left",
  COMPOSITION_DELIVERY_DATE: ".js-product-details-delivery-dates-current-composition-date",

  CART_CUTOFF: ".js-product-details-delivery-dates-current-cart-cutoff",
  CART_SHIPMENTS: ".js-product-details-delivery-dates-current-cart-shipments",
  CART_CUTOFF_TIME: ".js-product-details-delivery-dates-current-cart-left",
  CART_DELIVERY_DATE: ".js-product-details-delivery-dates-current-cart-date"
};

export default ({ cutoff, cart_dates, composition_dates }) => {
  const $generalCutoff = document.querySelector(SELECTORS.CUTOFF);

  const $compositionCutoff = document.querySelector(SELECTORS.COMPOSITION_CUTOFF);
  const $compositionSize = document.querySelector(SELECTORS.COMPOSITION_SIZE);
  const $compositionCutoffTime = document.querySelector(SELECTORS.COMPOSITION_CUTOFF_TIME);
  const $compositionDeliveryTime = document.querySelector(SELECTORS.COMPOSITION_DELIVERY_DATE);

  const $cartCutoff = document.querySelector(SELECTORS.CART_CUTOFF);
  const $cartShipments = document.querySelector(SELECTORS.CART_SHIPMENTS);
  const $cartCutoffTime = document.querySelector(SELECTORS.CART_CUTOFF_TIME);
  const $cartDeliveryTime = document.querySelector(SELECTORS.CART_DELIVERY_DATE);

  $generalCutoff.innerHTML = cutoff;

  $compositionCutoff.innerHTML = composition_dates.cutoff;
  $compositionSize.innerHTML = composition_dates.size;
  $compositionCutoffTime.innerHTML = composition_dates.timeleft;
  $compositionDeliveryTime.innerHTML = composition_dates.value;

  $cartCutoff.innerHTML = cart_dates.cutoff;
  $cartShipments.innerHTML = cart_dates.shipments
    .map(
      shipment => `<dl>
      <dt>${shipment.date}</dt>
      <dd>${shipment.items} items</dd>
    </dl>`
    )
    .join("");
  $cartCutoffTime.innerHTML = cart_dates.timeleft;
  $cartDeliveryTime.innerHTML = cart_dates.value;
};
